import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders } from '@angular/common/http';
import { HttpService } from '@app-core/services/http/http.service';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
@Injectable({
  providedIn: 'root',
})
export class ProductivityEventsService {
  filtersData = {
    customer: '',
    event: true,
    employees: [],
    years: '',
    months: '',
    day: '',
    order_by: '',
    order: '',
    events: [],
    date: null,
    page: 1,
    template: 1,
  };
  API_URL = `${environment.API_DOMAIN}/${environment.API_PATH_PREFIX}`;

  constructor(private httpService: HttpService) {}

  public getAllEvents({
    customer,
    event,
    employees,
    years,
    months,
    day,
    order_by,
    order,
    events,
    date,
    page,
    template,
  }): Observable<any> {
    const path = `${this.API_URL}/employee/kpi/`;
    let params = new HttpParams()
      .set('customer', customer)
      .set('event', event)
      .set('employee', employees.join(','))
      .set('years', years)
      .set('months', months)
      .set('day', day)
      .set('order_by', order_by)
      .set('order', order)
      .set('events', events.join(','))
      .set('page', page)
      .set('template', template);
    if (date) {
      params = params.set(
        'date_between',
        `${this.formatDateDB(date.startDate)},${this.formatDateDB(
          date.endDate
        )}`
      );
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getEventDetails(orderId): Observable<any> {
    const path = `${this.API_URL}/employee/kpi/${orderId}/`;
    const params = new HttpParams();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getEventType(): Observable<any> {
    const path = `${this.API_URL}/employee/kpi_eventsname/event_type_autocomplete/`;
    const params = new HttpParams().set('name', '');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getOrdersEventsCount({
    customer,
    employees,
    events,
    date,
  }): Observable<any> {
    const path = `${this.API_URL}/employee/kpi/count_events_and_orders/`;
    let params = new HttpParams()
      .set('customer', customer)
      .set('employee', employees.join(','))
      .set('events', events.join(','));
    if (date) {
      params = params.set(
        'date_between',
        `${this.formatDateDB(date.startDate)},${this.formatDateDB(
          date.endDate
        )}`
      );
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public getOrder({ customerId, orderNumber }): Observable<any> {
    const path = `${this.API_URL}/employee/kpi_position/order_autocomplete/`;
    const params = new HttpParams()
      .set('customer', customerId)
      .set('order', orderNumber);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  public createEvent(payload): Observable<any> {
    const path = `${this.API_URL}/employee/kpi_position/create_event/`;
    return this.httpService.post<any>(path, payload);
  }

  public getFilterData() {
    return this.filtersData;
  }

  formatDateDB(date) {
    const arrayDate = date.split('/');
    return `${arrayDate[2]}-${arrayDate[0]}-${arrayDate[1]}`;
  }

  formatDate(date) {
    const d = new Date(date);
    const year = d.getUTCFullYear();
    let month = '' + (d.getUTCMonth() + 1);
    let day = '' + d.getUTCDate();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [month, day, year].join('/');
  }
}
